import { BACKGROUNDS, BRAND, BRAND_PRIMARY_SCALE } from "../colors";
import type { ProtonColorScale, ProtonPalette } from "../types";

const LIGHT_GRAY = "#43464a";
export const BORDER = LIGHT_GRAY;
export const ELEVATION = "rgba(174, 175, 177, 0.2)";
export const DARK_GRAYSCALE: ProtonColorScale = {
  SUPER_DARK: "#111212",
  DARK: "#1e1f21",
  MEDIUM: "#232629",
  MEDIUM_LIGHT: "#2b2d30",
  LIGHT: LIGHT_GRAY,
  LIGHTEST: "#63676b",
  SUPER_LIGHT: "#8a8e91",
  WHITE: "#f7f9fb",
};

export const DARK_SECONDARY = {
  SUPER_DARK: "#142736",
  DARK: "#22445d",
  MEDIUM: "#306082",
  MEDIUM_LIGHT: "#3e7ca8",
  LIGHT: "#5795c1",
  LIGHTEST: "#a2c4dd",
  SUPER_LIGHT: "#dae7f1",
  WHITE: "#f7f9fb",
};

export const DARK_PALETTE: ProtonPalette = {
  BASE_COLOR: BACKGROUNDS.BLACK,
  BRAND,
  GRAYSCALE: DARK_GRAYSCALE,
  PRIMARY: BRAND_PRIMARY_SCALE,
  SECONDARY: DARK_SECONDARY,
} as const;
